/**
 * @description The next button will be visible only with this types only
 */
export const nextButtonVisibility = {
    name: 'name',
    email: 'email',
    gender: 'gender',
    'birth-date': 'birth-date',
    country: 'country',
    'email-consent': 'email-consent',
    cta: 'cta',
    vignette: 'vignette',
    upload: 'upload',
}; // show continue button for theses types only
